module.exports = __webpack_public_path__ + "static/media/instapro-message.602508b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/message/instapro-message.wav
// module id = dasV
// module chunks = 38